import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import bannerImage from "../../Images/Banner/acadmic.webp";
import classroomImage from "../../Images/gov-body/books.webp";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Row } from "react-bootstrap";
import "../../Placement.css";
import mom from "../../Images/Ordinances andStatute/MOM of AC meeting 25112022.pdf";

const pedagogyItems = [
  {
    icon: "🎓",
    title: "Expert Co-optation",
    description:
      "Co-opting members with specialized knowledge and experience to contribute to academic decision-making and transactions.",
  },
  {
    icon: "📚",
    title: "Promotion of Teaching & Research",
    description:
      "Actively fostering teaching, research, and related academic activities across the University.",
  },
  {
    icon: "🧭",
    title: "Academic Supervision",
    description:
      "Exercising overall supervision over the academic policies and programs of the University.",
  },
  {
    icon: "🔬",
    title: "Research Direction",
    description:
      "Providing direction and strategies to enhance academic standards and research methodologies.",
  },
  {
    icon: "💰",
    title: "Research Funding Proposal",
    description:
      "Submitting proposals to the Governing Body for the allocation of funds dedicated to research activities.",
  },
  {
    icon: "🏅",
    title: "Awards & Scholarships",
    description:
      "Proposing to the Governing Body the institution of fellowships, scholarships, medals, and awards, along with rules for their governance.",
  },
  {
    icon: "🤝",
    title: "Recognition of Experts",
    description:
      "Recognizing distinguished individuals as research guides/co-guides for interdisciplinary and multi-disciplinary subjects.",
  },
  {
    icon: "🏛️",
    title: "Organizational Schemes",
    description:
      "Formulating, modifying, and revising schemes for faculties, schools, and departments, subject to Governing Body approval.",
  },
];

const body = [
  {
    name: "Prof. (Dr) Anand Mahalwar",
    designation: "Chairperson",
    remarks: "Hon’ble Vice-Chancellor, ISBM University",
  },
  {
    name: "Dr. N. Kumar Swamy",
    designation: "Member",
    remarks: "Dean (In-charge), ISBM University",
  },
  {
    name: "Dr. Poonam Verma",
    designation: "Member",
    remarks: "HOD, Faculty of Science",
  },
  {
    name: "Dr. Garima Diwan",
    designation: "Member",
    remarks: "HOD, Faculty of Art & Humanity",
  },
  {
    name: "Mr. Rajendra Prasad",
    designation: "Member",
    remarks: "HOD, Faculty of Law",
  },
  {
    name: "Ms. Kesharlata Sahu",
    designation: "Member",
    remarks: "HOD, Faculty of Commerce & Management",
  },
  {
    name: "Shri Jitendra Nahar",
    designation: "Member",
    remarks: "Nominee, Chancellor, ISBM University",
  },
  {
    name: "Shri Munir Sayyad",
    designation: "Member",
    remarks:
      "Nominee, Chancellor, ISBM University — Address: Reliance Corporate Park Cabin No. 01, Ground floor, TC-23, Block-C, Phase-IC, Ghansoli, Navi Mumbai-400701 Maharashtra",
  },
  {
    name: "Mr. Bhushan Kumar Sahu",
    designation: "Member",
    remarks: "Asst. Professor, Zoology, Govt. College Gariyaband (CG)",
  },
  {
    name: "Mr. P.K. Bhoi",
    designation: "Member",
    remarks: "Principal, Govt. College Chhura, District – Gariyaband (CG)",
  },
  {
    name: "Mr. S.R. Vadde",
    designation: "Member",
    remarks:
      "Asst. Professor, Commerce, Shri Khuleshwar Mahadev Govt. College Gobra Nawapara, Raipur, C.G.",
  },
  {
    name: "Mr. Takeshwar Kaushik",
    designation: "Member",
    remarks: "HOD, Faculty of Engineering & Technology",
  },
  {
    name: "Ms. Vimla Sona",
    designation: "Member",
    remarks: "HOD, Faculty of Library & Information Science",
  },
  {
    name: "Dr. Barada Prasad Bhol",
    designation: "Member Secretary",
    remarks: "Registrar, ISBM University",
  },
  {
    name: "Dr. Aruna Ranasinghe",
    designation: "Member",
    remarks: "Professor, Faculty of Commerce & Management, ISBM University",
  },
  {
    name: "Prof. John White",
    designation: "Member",
    remarks: "Professor, Faculty of Law, ISBM University",
  },
];

const AcademicCouncil = () => {
  return (
    <>
      <title>Academic Council | ISBM University Leadership & Governance</title>
      <meta
        name="description"
        content="Discover ISBM University's Academic Council, which is dedicated to academic policies, curriculum development, and maintaining excellence in higher education."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="conatiner-xxl">
            <div className="section-hero-content">
              <h1>Academic Council – Driving Academic Excellence</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Board of Management
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-light">
        <div className="container-xxl ptb-50">
          <Row className="m-0">
            <div className="col-md-6">
              <h2 className="modern-title text-blue">Academic Council</h2>
              <div className="underline-divider mb-3"></div>
              <p className="text-muted">
                The Academic Council is the academic body of the University; it
                coordinates and exercises supervision over the policies and
                programmes of the University. The Vice-Chancellor of the
                University is the chairman of the council, presiding over the
                meetings. It is composed of Deans, Heads of Departments,
                Scientists, Academicians, Technocrats, and Industrialists, all
                of whom are nominated by the Chancellor
              </p>
              <p className="text-muted">
                Through regular deliberations and recommendations, the Academic
                Council upholds the University’s mission to foster intellectual
                excellence, promote interdisciplinary learning, and continuously
                upgrade curricula in alignment with global standards and
                evolving industry needs.
              </p>
            </div>
            <div className="col-md-6">
              <div className="governing-image-wrapper shadow">
                <img src={classroomImage} alt="Governing Body" />
              </div>
            </div>
          </Row>
        </div>
      </section>

      <section className="container-xxl ptb-50">
        <h2 className="text-center modern-title text-blue">
          Powers and functions of the Academic Council
        </h2>
        <div className="underline-center mb-5"></div>
        <div className="row m-0">
          {pedagogyItems.map((item, index) => (
            <div className="col-md-6 col-lg-4 mb-4" key={index}>
              <div className="d-flex h-100 border-end pe-3">
                <div className="me-3 fs-1 text-secondary">{item.icon}</div>
                <div>
                  <h6 className="fw-bold mb-2 text-dark">{item.title}</h6>
                  <p className="text-muted small mb-0">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="visa-section py-5 bg-light">
        <div className="container-xxl">
          <h2 className="text-center modern-title text-blue">Member of the Board of Management</h2>
          <div className="underline-center mb-5 mx-auto"></div>
          <div className="row m-0">
            {body.map((member, index) => (
              <div className="col-lg-4 col-md-6 d-flex mb-3" key={index}>
                <div className="visa-box p-4 shadow w-100 h-100 d-flex flex-column">
                  <div className="visahead">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h5 className="text-dark mb-0">{member.name}</h5>
                      <span className="badge designation ms-2 ">
                        {member.designation}
                      </span>
                    </div>
                    <div className="underlinetwo"></div>
                  </div>
                  <ul className="mb-0 list-unstyled">
                    <li>{member.remarks}</li>
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="meeting">
        <div className="edu_letter_main_wrapper container-xxl">
          <div className="container-xxl">
            <div className="row p-4 ">
              {/* Left Side Text */}
              <div className="col-md-6 d-flex flex-column justify-content-center">
                <h3 className="text-white fw-bold m-0">
                  MOM of Academic Council meeting
                </h3>
              </div>

              {/* Right Side Button */}
              <div className="col-md-6 text-md-end text-center">
                <div className="d-flex flex-column align-items-md-end gap-3">
                  <a
                    href={mom}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn download border fw-bold px-5 p-2"
                  >
                    Download MOM
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default AcademicCouncil;
